import {DotLoader} from "react-spinners";
import {useEffect, useState} from "react";

const Loader = () => {

    const [loadingProgress, setLoadingProgress] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const simulateLoading = () => {
            let progress = 0;
            const interval = setInterval(() => {
                progress += 5;
                setLoadingProgress(progress);
            }, 100);
        };

        simulateLoading();
    }, []);

    return (
        <>
            <DotLoader size={30} color={"#EF2E25"} loading={!isLoaded}/>
        </>
    )
}

export {Loader}